import { jsx as t } from "react/jsx-runtime";
import { Heading as i } from "../../Heading/index.js";
function n(e) {
  return /* @__PURE__ */ t(i, { ...e, level: 2, slot: "title" });
}
export {
  n as Heading
};
